import styled from 'styled-components';

export const WatchingWrapper = styled.div`
    width: 100%;
    height: 100%;
`;
